// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconChevronRight = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M46.8275 30.6366C46.028 29.7785 29.1239 11.6337 28.2615 10.7082C27.3992 9.78264 26.2786 9.76286 25.384 10.6574C24.4895 11.5518 23.5519 12.4894 22.6574 13.384C21.7629 14.2785 21.7827 15.3991 22.7083 16.2614C23.4299 16.9339 34.68 27.4147 39.6017 31.9999C34.68 36.5851 23.4299 47.0661 22.7082 47.7384C21.7827 48.6007 21.7628 49.7214 22.6574 50.6159L25.384 53.3426C26.2785 54.2371 27.3992 54.2172 28.2615 53.2917C29.1239 52.3661 46.028 34.2214 46.8275 33.3632C47.627 32.5052 47.627 31.4947 46.8275 30.6366Z" />
    </svg>
  );
};
